import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { OpenSans } from 'Shared/frontend/fonts/OpenSans';
import { Questrial } from '../fonts/Questrial';
import { Oswald } from 'Shared/frontend/fonts/Oswald';
import { INav } from 'Common/config/INav';
import { lazy } from 'solid-js';
import { fluidType } from 'Shared/common/FluidType';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';

import {PeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 


export class Showcase2Settings extends BaseSettings
{
	palette()
	{
		return{
			background: '#ffffff',
			text: '#000000',
			inverseText: '#ffffff',
			feature: '#83b0c3', //Sky blue //'#135864', // Logo Blue
			feature2: '#f8b30e', // Sun Yellow
			feature3: '#83b0c3', //Sky blue

			/* Eg the mobile nav colour */
			dimBackground: '#83b0c3', //Skyblue again

			food: '', 
			drinks: '',
			
		};
	}

	fontIncludes()
	{
		return [
			OpenSans,
			Questrial,
			Oswald 
//			Alatsi,
		];
	}

	fontsText()
	{
		return({
			fontFamily: '"Questrial", serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,18),		
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Oswald", sans-serif',
			letterSpacing: 3,
			lineHeight: 1.2,
			fontWeight: '400',
			color: this.palette().feature2,	
		
		})
	}

	fontsHeading2()
	{
		return({
			fontFamily: '"Questrial", sans-serif',
			color: this.palette().feature2,	
			fontWeight: '300',
			lineHeight: 1,		
		})
	}

	fontsHeading3()
	{
		return({
			fontFamily: '"Oswald", sans-serif',
			letterSpacing: 3,
			lineHeight: 1.2,
			fontWeight: '400',
			color: this.palette().feature,	
		})
	}
	
	fonts()
	{
		return {
			text: '"Questrial", sans-serif',
			heading: '"Oswald", sans-serif',
			subNav: '"Questrial", sans-serif',
			buttons: '"Questrial", sans-serif',
			desktopNav: '"Oswald", sans-serif',
			mobileNav: '"Oswald", sans-serif',
		};
	}

	//used on Teaser,Title,Tagline so they layout evenly and collapse when needed
	textMargins()
	{
		return({
			margin: '.3em 0',
		})
	}

	//For consistency on all navs inc sticky subs, hire, home, event lineups
	subNavButtons()
	{
		return({
			backgroundColor: this.palette().feature2,
			color: this.palette().background,
			borderRadius: '0.4em',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,15,20),
		})
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,50),
				textTransform: 'uppercase',
		
			},
			plain: {
				...this.fontsText(),
			},
			title: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,50),
				textTransform: 'uppercase',
				...this.textMargins(),
			},
			subtitle: {
				...this.fontsHeading3(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,30),
				
			},
			teaser: {
				...this.fontsHeading(),
				...this.textMargins(),
				//textTransform: 'uppercase',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,22,36),
			},
			tagline: {
				...this.fontsHeading3(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,22,36),	
			},

		});
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().feature3,
					//...this.fontsHeading(),
					fontSize: '16px',
					lineHeight: 1.1,
					color: this.palette().inverseText,

					
					
				},
				dateBar: {
					backgroundColor: this.palette().feature3,
					...this.fontsText(),
					fontSize: '16px',
					color: this.palette().inverseText,
					
				},
				squareImageWrap:{
					img:{
						//borderTopLeftRadius: 80,
						//borderBottomRightRadius: 80,
						clipPath: 'polygon(100% 0%, 0% 0% , 0.00% 85.79%, 1.00% 85.28%, 2.00% 84.81%, 3.00% 84.41%, 4.00% 84.07%, 5.00% 83.80%, 6.00% 83.60%, 7.00% 83.48%, 8.00% 83.43%, 9.00% 83.45%, 10.00% 83.55%, 11.00% 83.73%, 12.00% 83.97%, 13.00% 84.29%, 14.00% 84.67%, 15.00% 85.11%, 16.00% 85.61%, 17.00% 86.16%, 18.00% 86.76%, 19.00% 87.39%, 20.00% 88.05%, 21.00% 88.74%, 22.00% 89.44%, 23.00% 90.14%, 24.00% 90.85%, 25.00% 91.55%, 26.00% 92.23%, 27.00% 92.88%, 28.00% 93.51%, 29.00% 94.09%, 30.00% 94.63%, 31.00% 95.11%, 32.00% 95.54%, 33.00% 95.91%, 34.00% 96.21%, 35.00% 96.43%, 36.00% 96.59%, 37.00% 96.67%, 38.00% 96.68%, 39.00% 96.61%, 40.00% 96.47%, 41.00% 96.25%, 42.00% 95.96%, 43.00% 95.61%, 44.00% 95.19%, 45.00% 94.71%, 46.00% 94.18%, 47.00% 93.60%, 48.00% 92.99%, 49.00% 92.34%, 50.00% 91.66%, 51.00% 90.96%, 52.00% 90.26%, 53.00% 89.55%, 54.00% 88.85%, 55.00% 88.16%, 56.00% 87.49%, 57.00% 86.86%, 58.00% 86.26%, 59.00% 85.70%, 60.00% 85.19%, 61.00% 84.74%, 62.00% 84.35%, 63.00% 84.02%, 64.00% 83.76%, 65.00% 83.58%, 66.00% 83.46%, 67.00% 83.43%, 68.00% 83.46%, 69.00% 83.58%, 70.00% 83.76%, 71.00% 84.02%, 72.00% 84.35%, 73.00% 84.74%, 74.00% 85.20%, 75.00% 85.71%, 76.00% 86.26%, 77.00% 86.87%, 78.00% 87.50%, 79.00% 88.17%, 80.00% 88.86%, 81.00% 89.56%, 82.00% 90.27%, 83.00% 90.97%, 84.00% 91.67%, 85.00% 92.34%, 86.00% 92.99%, 87.00% 93.61%, 88.00% 94.19%, 89.00% 94.72%, 90.00% 95.19%, 91.00% 95.61%, 92.00% 95.96%, 93.00% 96.25%, 94.00% 96.47%, 95.00% 96.61%, 96.00% 96.68%, 97.00% 96.67%, 98.00% 96.59%, 99.00% 96.43%, 100.00% 96.20%)',
					},
				},

				imageWrap:{
					img:{
						//borderTopLeftRadius: 80,
						//borderBottomRightRadius: 80,
						clipPath: 'polygon(100% 0%, 0% 0% , 0.00% 85.79%, 1.00% 85.28%, 2.00% 84.81%, 3.00% 84.41%, 4.00% 84.07%, 5.00% 83.80%, 6.00% 83.60%, 7.00% 83.48%, 8.00% 83.43%, 9.00% 83.45%, 10.00% 83.55%, 11.00% 83.73%, 12.00% 83.97%, 13.00% 84.29%, 14.00% 84.67%, 15.00% 85.11%, 16.00% 85.61%, 17.00% 86.16%, 18.00% 86.76%, 19.00% 87.39%, 20.00% 88.05%, 21.00% 88.74%, 22.00% 89.44%, 23.00% 90.14%, 24.00% 90.85%, 25.00% 91.55%, 26.00% 92.23%, 27.00% 92.88%, 28.00% 93.51%, 29.00% 94.09%, 30.00% 94.63%, 31.00% 95.11%, 32.00% 95.54%, 33.00% 95.91%, 34.00% 96.21%, 35.00% 96.43%, 36.00% 96.59%, 37.00% 96.67%, 38.00% 96.68%, 39.00% 96.61%, 40.00% 96.47%, 41.00% 96.25%, 42.00% 95.96%, 43.00% 95.61%, 44.00% 95.19%, 45.00% 94.71%, 46.00% 94.18%, 47.00% 93.60%, 48.00% 92.99%, 49.00% 92.34%, 50.00% 91.66%, 51.00% 90.96%, 52.00% 90.26%, 53.00% 89.55%, 54.00% 88.85%, 55.00% 88.16%, 56.00% 87.49%, 57.00% 86.86%, 58.00% 86.26%, 59.00% 85.70%, 60.00% 85.19%, 61.00% 84.74%, 62.00% 84.35%, 63.00% 84.02%, 64.00% 83.76%, 65.00% 83.58%, 66.00% 83.46%, 67.00% 83.43%, 68.00% 83.46%, 69.00% 83.58%, 70.00% 83.76%, 71.00% 84.02%, 72.00% 84.35%, 73.00% 84.74%, 74.00% 85.20%, 75.00% 85.71%, 76.00% 86.26%, 77.00% 86.87%, 78.00% 87.50%, 79.00% 88.17%, 80.00% 88.86%, 81.00% 89.56%, 82.00% 90.27%, 83.00% 90.97%, 84.00% 91.67%, 85.00% 92.34%, 86.00% 92.99%, 87.00% 93.61%, 88.00% 94.19%, 89.00% 94.72%, 90.00% 95.19%, 91.00% 95.61%, 92.00% 95.96%, 93.00% 96.25%, 94.00% 96.47%, 95.00% 96.61%, 96.00% 96.68%, 97.00% 96.67%, 98.00% 96.59%, 99.00% 96.43%, 100.00% 96.20%)',
					},
				},
				/*Overlapping Bens development version
				types: {
					overlapping: {
						name:{
							textTransform: 'initial !important',
						},
						eventTagline:{
							fontSize: '.8em !important'
						}
					},
				},
				*/
			},
		});
	}

	page()
	{
		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

			heading: {
				color: this.palette().feature,
			},
			
			section: {},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
				color: this.palette().background,
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,20),
			},

			widgets: {

				scrollStyle:{
					scrollbarColor: 'white #ced6dc !important',
				},

				grid: {
					columnGap: '2vw',
					rowGap: '2vw',
				},

				overlay: {

					'.text-teaser':{
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,24,32),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,40),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
						letterSpacing: 1,
					},
					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,30),
						fontWeight: '300',
						textShadow: '0 0 5px black',
						letterSpacing: 1,
						color: this.palette().inverseText,
					},

					'.text-plain': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,24),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					
					button: {
						backgroundColor: this.palette().feature,
						borderRadius: '0.4em',
						color: this.palette().inverseText,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,20),
					},
				},
				subNav: {
					button: {
						...this.subNavButtons(),
					}
				},
			},
		});
	}
//navigation
	//navigation settings
	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				type: 'standard',
				
				settings: {
					fadeBackgroundIn: false, 
					outer: {background: palette.feature3,},
					
					logo:{
						padding: '10px 0px',
					},	
					button: {
						...this.fontsHeading(),
						color: palette.inverseText,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,14,25),
				
					},
				
					active: {
						color: palette.feature2,
					},


					hover: {
						color: palette.feature2,
					},

					
				}
			},

			mobile:{		
				overlay:{background: palette.feature3},
		
				button:{
					...this.fontsText(),
					color: palette.inverseText,
					background: palette.feature3,
					textTransform: 'uppercase',
					

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.inverseText} !important`
					},

					':hover': {
					//TODO cf remove from BaseTheme?						
						backgroundColor: this.palette().feature,
					}
				},
				active: {
					color: palette.feature2,
					svg:{
						fill: `${palette.feature2} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.feature3,

					},
					button: {
						':hover': {
							color: this.palette().inverseText,
							backgroundColor: this.palette().feature,
						}
					}
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		base.specials = {
			general: 'General',
			beers: 'Beers'
		};

		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					button:{
						...this.subNavButtons(),
					}
				},

				heading: {
					...this.fontsHeading2(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
					color: palette.feature
				},
				artist: {
					heading: {
						color: palette.feature2,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature,
						}
					}, 
					genresAndLocation: {
						color: palette.feature2
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						...this.subNavButtons(),
					},
		
				},
				section: {
					marginBottom: '3em'
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsText(),
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),	
					
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menu',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon: Home},
					{label:'Menu',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon: Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon: Contact},
					{label:'Contact',	link:'frontend/Contact',	icon: Contact},
				]
			}
		};
	}

	routes()
	{
		return class extends super.routes() {
			frontendContent()
			{
				return [
					...super.frontendContent(),
					
				];
			}
		};
	}
}

